import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { hot } from 'react-hot-loader/root';
import { Provider, useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import Admin from './routes/admin'; //calling admin
import Auth from './routes/auth'; //calling auth
import Exam from './routes/ExamURL';
//calling auth
import './static/css/styleNew.css';
import './static/css/style.css';
import config from './config/config'; //config-------------------------------1
import store from './redux/store'; //calling store---------------------------2
import ProtectedRoute from './components/utilities/protectedRoute';
import Cookies from 'js-cookie';

Axios.defaults.withCredentials = true;
const { theme } = config;
var ExamUrl;
var ExamURL1;
const ProviderConfig = () => {
  const { rtl, isLoggedIn, topMenu, darkMode } = useSelector(state => {
    return {
      darkMode: state.ChangeLayoutMode.data,
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
      isLoggedIn: state.auth.login,
    };
  });

  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      setPath(window.location.pathname);
    }
    return () => (unmounted = true);
  }, [setPath]);
  var sessionID = Cookies.get('sessionID');
  useEffect(() => {
    if (sessionID == undefined) {
      var create_session = randomstring(32);
      Cookies.set('sessionID', create_session);
      // SetAccessTokenCookies(create_session)
    } else {
      // console.log("already in cookies");
      sessionID = Cookies.get('sessionID');
    }
  }, []);
  function randomstring(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  const splitedURL = window.location.pathname.split('/');
  var PathArray = [
    'about',
    'blog',
    'services',
    'contact',
    'portfolio',
    'pricing',
    'pickup',
    'register',
    'login',
    'Account_details',
    'notification',
    'Edit_Profile',
    'notification',
    'category',
    'Checkout',
    'cart',
    'forgotPassword',
    'oneTimePassword',
    'verifiedaccount',
    'resetPassword',
    'order',
    'sign-in',
  ];
  // if (splitedURL[1] == 'about') {
  //   ExamUrl = splitedURL?.[1];
  //   ExamURL1 = 'home';
  // } else if (splitedURL[1] == 'blog') {
  //   ExamUrl = splitedURL?.[1];
  //   ExamURL1 = 'home';
  // } else if (splitedURL[1] == 'services') {
  //   ExamUrl = splitedURL?.[1];
  //   ExamURL1 = 'home';
  // } else if (splitedURL[1] == 'quiz') {
  //   ExamUrl = splitedURL?.[1];
  //   ExamURL1 = 'home';
  // } else if (splitedURL[1] == 'contact') {
  //   ExamUrl = splitedURL?.[1];
  //   ExamURL1 = 'home';
  // } else if (splitedURL[1] == 'portfolio') {
  //   ExamUrl = splitedURL?.[1];
  //   ExamURL1 = 'home';
  // } else if (splitedURL[1] == 'pricing') {
  //   ExamUrl = splitedURL?.[1];
  //   ExamURL1 = 'home';
  // }

  if (PathArray.includes(splitedURL?.[1])) {
    ExamUrl = 'home';
  }

  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
      <ThemeProvider theme={{ ...theme, rtl, topMenu, darkMode }}>
        {ExamUrl != 'home' ? (
          <Router basename={process.env.PUBLIC_URL}>
            {!isLoggedIn ? <Route path="/" component={Auth} /> : <ProtectedRoute path="/dashboard" component={Admin} />}
            {isLoggedIn && (path === process.env.PUBLIC_URL || path === `${process.env.PUBLIC_URL}/`) && (
              <>
                <Redirect to="/dashboard" />
                <Route path="/" component={Auth} />
              </>
            )}
          </Router>
        ) : (
          <Router basename={process.env.PUBLIC_URL}>
            <Route path="/" component={Exam} />
          </Router>
        )}
      </ThemeProvider>
    </ConfigProvider>
  );
};
function App() {
  return (
    <Provider store={store}>
      <ProviderConfig />
    </Provider>
  );
}

export default hot(App);
